import {handleResponse, authHeader} from '../helpers';
const BASE_URL = process.env.REACT_APP_API_URL;
export const roleService = {
	getManagedPeople,
	getRoleList,
	saveUserRole
}

function getManagedPeople() {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(BASE_URL + `/internal/users`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function getRoleList() {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(BASE_URL + `/internal/roles`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function saveUserRole(data) {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(data)
	};

	return fetch(BASE_URL + `/internal/users`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}
